import type { LucideIcon } from 'lucide-react'
import { TrendingUp, TrendingDown } from 'lucide-react'

interface StatCardProps {
  label: string
  value: string
  trend?: number // % change
  icon: LucideIcon
  color?: 'red' | 'blue' | 'emerald' | 'amber' | 'violet'
}

const colors = {
  red: 'bg-red-50 text-red-600',
  blue: 'bg-blue-50 text-blue-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  violet: 'bg-violet-50 text-violet-600',
}

export function StatCard({ label, value, trend, icon: Icon, color = 'red' }: StatCardProps) {
  const positive = (trend ?? 0) >= 0
  return (
    <div className="rounded-2xl border border-ink-200 bg-white p-5 transition-all hover:shadow-md">
      <div className="flex items-start justify-between">
        <div className="text-sm font-medium text-ink-500">{label}</div>
        <div className={`grid size-9 place-items-center rounded-lg ${colors[color]}`}>
          <Icon className="size-4" />
        </div>
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className="text-2xl font-extrabold tracking-tight text-ink-900">{value}</div>
        {trend !== undefined && (
          <div
            className={`inline-flex items-center gap-0.5 text-xs font-semibold ${
              positive ? 'text-emerald-600' : 'text-red-600'
            }`}
          >
            {positive ? <TrendingUp className="size-3" /> : <TrendingDown className="size-3" />}
            {positive ? '+' : ''}
            {trend}%
          </div>
        )}
      </div>
      <div className="mt-1 text-[10px] uppercase tracking-wider text-ink-500">vs ayer</div>
    </div>
  )
}
